import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import SidebarLoginActions from './SidebarLoginActions';
import AdminMenu from './AdminMenu';
import logo from '../../static/logo.svg';
import {
  is_manager
} from '../helpers/'
import {
  logoutUser
 } from '../actions/'

const mapDispatchToProps = dispatch => {
  return {
		logOutUser: () => dispatch ( logoutUser() ),
  }
}

const mapStateToProps = state => {
	return {
		current_user: state.auth.current_user,
    showingProject: state.report.showingProject,
    showingProjectArchive: state.report.showingProjectArchive,
    report: state.report.report,
    entry: state.entry
	}
}

class ConnectedSidebar extends React.Component {

	render() {
    // const isAdmin = (this.props.current_user.data !== undefined && this.props.current_user.data.role === "admin")
		let isLoggedOnComp;
		let sidebarMsg;
    const collapsed = (this.props.collapsed === true)
		if ( this.props.loggedOn ) {
			isLoggedOnComp = <SidebarLoginActions collapsed/>
			const username = (typeof(this.props.current_user.data) === "undefined") ? '' : this.props.current_user.data.name
      const sidebarLogout = (this.props.collapsed === true) ? (<i className="material-icons">settings_power</i>) : "Logout"
			sidebarMsg = <span title="Logout">Welcome, {username} - <a href='' onClick={ (e) => {
					e.preventDefault()
					this.props.logOutUser()
				}}>{ sidebarLogout  }</a></span>;
		} else {
			sidebarMsg = <span>Welcome! Please, fill in your login credentials to enter.</span>
		}

    let reportActions;
    const archived_instances_title = collapsed ? 'Archived Instances' : ""
    const project_overview_title = collapsed ? 'Project Overview' : ""


    if (this.props.showingProject) {
      const id = (typeof(this.props.report.id) === "undefined") ? this.props.entry.master_id : this.props.report.id;
      reportActions = (
        <div>
          <hr />
          <Link to={`/projects/${id}/archive`} className="btn red darken-1 waves-effect waves-light left-align" title={archived_instances_title}>
            <i className="material-icons white-text secondary-content">delete</i>{"Archived Instances"}
          </Link>
        </div>
      )
    } else if (this.props.showingProjectArchive) {
      const id = (typeof(this.props.report.id) === "undefined") ? this.props.entry.master_id : this.props.report.id;
      reportActions = (
        <div>
          <hr />
          <Link to={`/projects/${id}`} className="btn red darken-1 waves-effect waves-light left-align" title={project_overview_title}>
            <i className="material-icons white-text secondary-content">list</i>{"Project Overview"}
          </Link>
        </div>
      )
    } else {
      reportActions = ''
    }

    const collapseAction = (this.props.collapsed === true) ? (
      <div title="Expand" className="collapseButton">
        <a href='' className="btn" onClick={ e => {
          e.preventDefault()
          this.props.expand()
        }}>
          <i className="material-icons white-text secondary-content">navigate_next</i>
        </a>
      </div>
    ) : (
      <div title="Collapse" className="collapseButton">
        <a href='' className="btn" onClick={ e => {
          e.preventDefault()
          this.props.collapse()
        }}>
          <i className="material-icons white-text secondary-content">navigate_before</i>Collapse
        </a>
      </div>
    )

    const headerClass = ( this.props.collapsed === true ) ? "page-header" : "page-header center-align"
    const logoText = ( this.props.collapsed === true ) ? (<span>Monster<br/>Optimization<br/>Module<br/></span>) : "Monster Optimization Module"

    const adminActions = is_manager() ? <AdminMenu /> : ""
		return(
				<div className="col s12 l3 xl2 grey lighten-4 nav-fixed">
					<div className={ headerClass }>
						<div className="section">
							<a href="/"><img src={logo} alt="logo" /></a>
							<h1 className="flow-text logo-text">{ logoText }</h1>
						</div>
					</div>

					<div className="links">
						<div className="valign-wrapper card-panel user-panel">
							<div className="col s2">
								<i className="material-icons">account_circle</i>
							</div>
							<div className="col s10">
                { (this.props.collapsed && this.props.loggedOn ) ? <hr /> : ''}
								{ sidebarMsg }
							</div>
						</div>

						{ isLoggedOnComp }
            { reportActions }
            { adminActions }
            { collapseAction }
					</div>
				</div>
		)
	}
}

const Sidebar = connect(mapStateToProps, mapDispatchToProps)(ConnectedSidebar);

export default Sidebar;



// WEBPACK FOOTER //
// ./src/js/components/Sidebar.js